import axios from 'axios';

import config from '@config/index';

const publicApiClient = axios.create({
  baseURL: config.BACKEND_URI,
  headers: { 'Content-Type': 'application/json' },
});

export default publicApiClient;
